export default __webpack_public_path__ + "static/6629-03d852ae139940c79f8a7fef3d725a2d.jpg";